'use strict';

require('./annotations');
require('./measurements');
require('./overlays');
require('./confirmation');

const navLeft = angular.module('dash.nav.left', [
  'dash.nav.left.annotations',
  'dash.nav.left.measurements',
  'dash.nav.left.overlays',
  'dash.nav.left.confirmation'
]);

navLeft.config(require('./NavConfig'));
navLeft.controller('NavLeftController', require('./NavLeftController'));
navLeft.directive('navLeft', require('./NavLeftDirective'));


// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/index.js